import React, { useEffect, useState } from "react";
import "./AdminTransactionHistory.css";
import { getTransactionHistory, getInvoicePreview } from "../../../services/payment/api";
import { useLocation, useParams } from "react-router-dom";
import InvoiceModal from "../../Payment/Invoices/InvoiceModal";

const TransactionHistory = () => {
  const { clientId } = useParams();
  const location = useLocation();
  const client = location.state?.client;

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [invoiceHtml, setInvoiceHtml] = useState("");
  
  // Toast Alert State Engine
  const [toast, setToast] = useState({ show: false, message: "", type: "" });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: "", type: "" }), 4000);
  };

  useEffect(() => {
    if (clientId) {
      loadTransactions();
    }
  }, [clientId]);

  const loadTransactions = async () => {
    try {
      setLoading(true);
      const data = await getTransactionHistory(clientId);
      setTransactions(data || []);
      showToast("Transaction records sync verified successfully!", "success");
    } catch (error) {
      console.error("Error fetching transaction history", error);
      setTransactions([]);
      showToast("Failed to populate client history stream logs.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenInvoice = async (id, type) => {
    if (!id) {
        showToast("No data reference found for this statement row.", "error");
        return;
    }
    try {
        showToast("Opening statement file context...", "info");
        const htmlContent = await getInvoicePreview(id, type);
        setInvoiceHtml(htmlContent);
        setModalOpen(true);
    } catch (err) {
        showToast("Error processing data sheet visualization layout.", "error");
    }
};

  return (
    <div className="transaction-wrapper">
      {/* Dynamic Floating Toast DOM Structure */}
      {toast.show && (
        <div className={`custom-toast toast-${toast.type}`}>
          {toast.message}
        </div>
      )}

      <div className="transaction-header">
        <h2>Transaction History</h2>
      </div>

      {/* Client Details */}
      <div className="transaction-client-card">
        <div className="transaction-client-info">
          <div className="transaction-client-item">
            <label>Client Name</label>
            <span>{client?.username || "-"}</span>
          </div>
          <div className="transaction-client-item">
            <label>Company Name</label>
            <span>{client?.companyName || "-"}</span>
          </div>
          <div className="transaction-client-item">
            <label>Client User ID</label>
            <span>{client?.email || "-"}</span>
          </div>
        </div>
      </div>

      {/* Transaction Table */}
      <div className="transaction-table-card">
        <div className="transaction-table-container">
          <table className="transaction-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Transaction Type</th>
                <th>Description</th>
                <th>Credits</th>
                <th>Balance</th>
                <th>Reference ID</th>
                <th>Status</th>
                <th>Invoices</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="transaction-loading">Loading...</td>
                </tr>
              ) : transactions.length === 0 ? (
                <tr>
                  <td colSpan="9" className="transaction-empty">No Transaction History Available</td>
                </tr>
              ) : (
                transactions.map((transaction, index) => (
                  <tr key={transaction.transactionId}>
                    <td>{index + 1}</td>
                    <td>
                      {transaction.createdAt
                        ? new Date(transaction.createdAt).toLocaleString()
                        : "-"}
                    </td>
                    <td>
                      <span className={`transaction-type ${transaction.transactionType === "RECHARGE" ? "recharge" : "deduction"}`}>
                        {transaction.transactionType}
                      </span>
                    </td>
                    <td>{transaction.description}</td>
                    <td className={transaction.transactionType === "RECHARGE" ? "credit-added" : "credit-deducted"}>
                      {transaction.transactionType === "RECHARGE" ? `+ ₹${transaction.credits}` : `- ₹${transaction.credits}`}
                    </td>
                    <td>₹ {transaction.balanceAfterTransaction}</td>
                    <td>{transaction.referenceId || "-"}</td>
                    <td>
                      <span className={`transaction-status ${transaction.status === "SUCCESS" ? "success" : "failed"}`}>
                        {transaction.status}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="view-invoice-btn" 
                        onClick={() => {
                          const isRecharge = transaction.transactionType === "RECHARGE";
                          const targetId = isRecharge ? transaction.rechargeId : transaction.transactionId;
                          handleOpenInvoice(targetId, transaction.transactionType);
                        }}
                        disabled={transaction.transactionType === "RECHARGE" && !transaction.rechargeId}
                      >
                          View
                      </button>
                  </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <InvoiceModal 
        isOpen={modalOpen} 
        htmlContent={invoiceHtml} 
        onClose={() => setModalOpen(false)} 
      />
    </div>
  );
};

export default TransactionHistory;